import script from "./compGroupsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./compGroupsTable.vue?vue&type=script&setup=true&lang=js"

import "./compGroupsTable.vue?vue&type=style&index=0&id=225fcda0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-225fcda0"]])

export default __exports__